import Button from '@eversports/react-components/primitives/Button'
import { VerticalFlex } from '@eversports/react-components/primitives/Flex'
import MenuItem from '@eversports/react-components/primitives/MenuItem'
import Select from '@eversports/react-components/primitives/Select'
import PyroForm, { Form } from 'pyro-form'
import { useSelectStudioTypesSportsQuery } from '../../graphql'
import { useIntl } from '../../localization/react'
import { COUNTRIES, BUSINESS_TYPES, MAIN_VERTICALS, AGGREGATORS } from './RegistrationStart.constants'
import { PreRegistrationData } from './RegistrationStart.types'
import SearchableSportsSelect from './SearchableSportsSelect'

interface RegistrationFormProps {
  initialValues: PreRegistrationData
  loading: boolean
  onSubmit: (values: PreRegistrationData) => void
  errors?: any
}

function RegistrationForm({ initialValues, loading, onSubmit, errors }: RegistrationFormProps) {
  const { data: sportsData } = useSelectStudioTypesSportsQuery()
  const intl = useIntl()

  const defaultValues: PreRegistrationData = {
    ...initialValues,
  }

  const handleValidate = (values: PreRegistrationData) => {
    const validationErrors: any = {}

    if (!values.country) validationErrors.country = intl('registration-form-country-required')
    if (!values.businessType) validationErrors.businessType = intl('registration-form-business-type-required')
    if (!values.mainVertical) validationErrors.mainVertical = intl('registration-form-main-vertical-required')
    if (!values.sports || values.sports.length === 0) {
      validationErrors.sports = intl('registration-form-sports-required')
    }
    if (!values.previousSoftware) validationErrors.previousSoftware = intl('registration-form-aggregator-required')

    return validationErrors
  }

  return (
    <PyroForm initialValues={defaultValues} onSubmit={onSubmit} onValidate={handleValidate} errors={errors}>
      {({ hasErrors }) => (
        <Form>
          <VerticalFlex style={{ marginTop: 24, gap: '24px' }}>
            <Select name="country" label={intl('registration-form-country-label')} fullWidth>
              {COUNTRIES.map((country) => (
                <MenuItem key={country.code} value={country.code}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>

            <Select name="businessType" label={intl('registration-form-business-type-label')} fullWidth>
              {BUSINESS_TYPES.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>

            <Select name="mainVertical" label={intl('registration-form-main-sport-type-label')} fullWidth>
              {MAIN_VERTICALS.map((vertical) => (
                <MenuItem key={vertical.value} value={vertical.value}>
                  {vertical.label}
                </MenuItem>
              ))}
            </Select>

            <SearchableSportsSelect
              name="sports"
              label={intl('registration-form-sports-label')}
              sports={sportsData?.sports || []}
              fullWidth
            />

            <Select name="previousSoftware" label={intl('registration-form-aggregator-label')} fullWidth>
              {AGGREGATORS.map((aggregator) => (
                <MenuItem key={aggregator.value} value={aggregator.value}>
                  {aggregator.label}
                </MenuItem>
              ))}
            </Select>

            <Button type="submit" fullWidth variant="primary" disabled={loading || hasErrors}>
              {loading ? intl('registration-form-submit-creating') : intl('registration-form-submit-continue')}
            </Button>
          </VerticalFlex>
        </Form>
      )}
    </PyroForm>
  )
}

export { RegistrationForm }
